import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.TourBlockouts.Title',
    defaultMessage: 'Tour Blockouts',
  },
  countName: {
    id: 'App.TourBlockouts.CountName',
    defaultMessage: 'Blockouts',
  },
  addBlockout: {
    id: 'App.TourBlockouts.AddBlockout',
    defaultMessage: 'Add Blockout',
  },
  emptyState: {
    id: 'App.TourBlockouts.EmptyState',
    defaultMessage: 'No tour blockouts at this property',
  },
  loadError: {
    id: 'App.TourBlockouts.LoadError',
    defaultMessage: 'Tour blockouts could not be loaded. Please try again.',
  },
  start: {
    id: 'App.TourBlockouts.Start',
    defaultMessage: 'Start',
  },
  end: {
    id: 'App.TourBlockouts.End',
    defaultMessage: 'End',
  },
  label: {
    id: 'App.TourBlockouts.Label',
    defaultMessage: 'Label',
  },
  slotsBlocked: {
    id: 'App.TourBlockouts.SlotsBlocked',
    defaultMessage: 'Slots Blocked',
  },
  delete: {
    id: 'App.TourBlockouts.Delete',
    defaultMessage: 'Delete',
  },
  addTitle: {
    id: 'App.TourBlockouts.AddTitle',
    defaultMessage: 'Add Tour Blockout',
  },
  editTitle: {
    id: 'App.TourBlockouts.EditTitle',
    defaultMessage: 'Edit Tour Blockout',
  },
  propertyTimezone: {
    id: 'App.TourBlockouts.PropertyTimezone',
    defaultMessage: "Times are in the property's time zone ({timezone}).",
  },
  noPropertyTimezone: {
    id: 'App.TourBlockouts.NoPropertyTimezone',
    defaultMessage:
      "This property has no time zone set, so times are in your computer's time zone.",
  },
  skippedTime: {
    id: 'App.TourBlockouts.SkippedTime',
    defaultMessage:
      "This time doesn't exist at the property: the clocks skip ahead an hour that night.",
  },
  saveError: {
    id: 'App.TourBlockouts.SaveError',
    defaultMessage: 'The tour blockout could not be saved. Please try again.',
  },
  deleteTitle: {
    id: 'App.TourBlockouts.DeleteTitle',
    defaultMessage: 'Delete tour blockout?',
  },
  deleteBody: {
    id: 'App.TourBlockouts.DeleteBody',
    defaultMessage: 'Delete "{label}"?',
  },
  deleteConfirmation: {
    id: 'App.TourBlockouts.DeleteConfirmation',
    defaultMessage:
      'Are you sure you want to delete this tour blockout? This action cannot be undone.',
  },
  deleteError: {
    id: 'App.TourBlockouts.DeleteError',
    defaultMessage: 'The tour blockout could not be deleted. Please try again.',
  },
  created: {
    id: 'App.TourBlockouts.Created',
    defaultMessage: 'Tour blockout added',
  },
  updated: {
    id: 'App.TourBlockouts.Updated',
    defaultMessage: 'Tour blockout updated',
  },
  deleted: {
    id: 'App.TourBlockouts.Deleted',
    defaultMessage: 'Tour blockout deleted',
  },
});

export default messages;
